module.exports = __webpack_public_path__ + "img/appleStore.583cfb37.svg";